module.exports = __webpack_public_path__ + "elephant-fren-d16fd77f9a9387e7d146b5f9d4dc1e7f.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant-fren.png
// module id = 254
// module chunks = 76